import { axiosGetOrPost  } from "@/utils/common.js";
// const baseUrl = "http://106.15.178.195:30004/LianOuService/"


const GetInquiryWxOpenQrCode = (params,tipText) => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiryWxOpenQrCode`,params);//获取店铺问诊小程序二维码
const GetInquiryWxOpenQrCode_Base64 = (params,tipText) => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiryWxOpenQrCode_Base64`,params);//获取店铺问诊小程序二维码
const GetDrugList = (params,tipText) => axiosGetOrPost("get",`api/v3/Inquiry/GetDrugList`,params,"搜索中");//搜索药品
const GetDrugByUpcCode = (params,tipText) => axiosGetOrPost("get",`api/v3/Inquiry/GetDrugByUpcCode`,params,"搜索中");//根据条形码获取药品信息
const GetUsedDrugsList = (params,tipText) => axiosGetOrPost("get",`api/v3/Inquiry/GetUsedDrugsList`,params);//获取药品使用记录
const GetDiseaseList =(params) => axiosGetOrPost("get",`api/v3/Inquiry/GetDiseaseList`,params,"搜索中");//搜索疾病
const SaveInquiry = (params) => axiosGetOrPost("post",`api/v3/Inquiry/SaveInquiry`,params,"保存问诊中");//新增问诊信息（包括续方）
const UpLoadImg = (data) => post(`LianOuService/UpLoadImg`,data,"上传中");//上传图片
const GetInquiryQrCode = (data)=>axiosGetOrPost("get","api/v3/Inquiry/GetInquiryQrCode",data);//微信问诊二维码
const GetPatientList = (data)=>axiosGetOrPost("get","api/v3/Inquiry/GetPatientList",data);//获取用药人列表
const GetDiagnoseByComNames = (data)=>axiosGetOrPost("get","api/v3/Inquiry/GetDiagnoseByComNames",data);//根据药品获取常用疾病
const SavePatient = (data)=>axiosGetOrPost("post","api/v3/Inquiry/SavePatient",data);//保存用药人信息，身份证是唯一或者openId是唯一
const GetPatient = (data)=>axiosGetOrPost("get","api/v3/Inquiry/GetPatient",data);//获取用药人信息
const GetInquiryList = params => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiryList`, params,null,true);//问诊列表信息
const AgeFrontCheck = params => axiosGetOrPost("post",`api/v3/Inquiry/AgeFrontCheck`, params,"加载中");//年龄前端校验，校验通过后才能发起问诊
const GetInquiry = (data) => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiry`,data);//获取问诊信息
const GetPrescribe = (params) => axiosGetOrPost("get",`api/v3/Inquiry/GetPrescribe`,params);  //获取处方信息
const GetOrderList = (params) => axiosGetOrPost("get",`api/v3/Inquiry/GetOrderList`,params,null,true);  //获取处方列表
const GetInquiryPicCode = (params) => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiryPicCode`,params);  //续方时获取问诊处方图片
const GetPackage = (params) => axiosGetOrPost("get",`api/v3/Shop/GetPackage`,params);  //获取套餐信息接口 套餐使用量每小时更新一次
const CheckPhar = (params) => axiosGetOrPost("get",`api/v3/Inquiry/CheckPhar`,params);  //检测是否有药师签名
const EditShopUser = (params) => axiosGetOrPost("post",`api/v3/ShopUser/EditShopUser`,params);  //管理员在APP端编辑店铺普通成员or药师完善信息 编辑店铺成员时，药师标识（IsPharmacist）可以为1或0 完善药师信息时，药师标识（IsPharmacist）只能为1
const AuditPrescribeV2 = (data)=>axiosGetOrPost("get","api/v3/Inquiry/AuditPrescribeV2",data);//药师审核处方
const BuyPackageList = (data)=>axiosGetOrPost("get","api/v3/Shop/BuyPackageList",data);//套餐购买列表

const UploadShopPic = (data) => axiosGetOrPost("post",`api/v3/Shop/UploadShopPic`, data) //单张图片上传
const ExistShopName = (data) => axiosGetOrPost("get",`api/v3/Shop/ExistShopName`, data) //判断店铺名是否存在 true-店铺名存在 false -店铺名不存在
const GetShopFromImg = (data) => axiosGetOrPost("get",`api/v3/Shop/GetShopFromImg`, data) //图片识别接口 从营业执照图片内获取店铺的信息
const AddShop = (data) => axiosGetOrPost("post",`api/v3/Shop/AddShop`, data) //申请店铺
const EditShop = (data) => axiosGetOrPost("post",`api/v3/Shop/EditShop`, data) //修改申请店铺
const GetPicCodeByUrl = (data) => axiosGetOrPost("get",`api/v3/Shop/GetPicCodeByUrl`, data) //获取图片code
const AddChainShop = (data) => axiosGetOrPost("post",`api/v3/Shop/AddChainShop`, data) //图片识别接口 从营业执照图片内获取店铺的信息
const GetShopApplyInfo = (data) => axiosGetOrPost("get",`api/v3/Shop/GetShop`, data) //获取店铺详情

const GetShopUser = (data) => axiosGetOrPost("get",`api/v3/Shop/GetShopUser`, data) //管理员或店铺成员自己获取成员详情

const GetPharSignList = (data) => axiosGetOrPost("get",`api/v3/Inquiry/GetPharSignList`, data) //获取店铺所有药师

const CheckPharV2 = (data) => axiosGetOrPost("get",`api/v3/Inquiry/CheckPharV2`, data) //检测是否有药师权限

const SaveSignType = (data) => axiosGetOrPost("post",`api/v3/Inquiry/SaveSignType`, data) //保存药师签名配置

const SearchDoctor = (data) => axiosGetOrPost("get",`api/v3/Shop/SearchDoctor`, data) //获取医生列表

const GetPharmacistInfo = (data) => axiosGetOrPost("get",`api/v3/Shop/GetPharmacistInfo`, data) //获取医生列表


const UnifiedOrder = (data) => axiosGetOrPost("post",`api/v3/Pay/UnifiedOrder`, data,"订单生成中") //支付


const GetDoctorInfo = (data) => axiosGetOrPost("get",`api/v3/Shop/GetDoctorInfo`, data) //医生详情

const IOSLogin = (data) => axiosGetOrPost("get",`api/v3/Account/IOSLogin`, data) //驗證繁體

const GetInquiryEncodeData = (data) => axiosGetOrPost("get",`api/v3/Inquiry/GetInquiryEncodeData`, data) //问诊详情 查看身份证完整数据

const GetSilkBagShortchain = (data) => axiosGetOrPost("get",`api/v3/Inquiry/GetSilkBagShortchain`, data) //获取短链接口

export{
    GetInquiryWxOpenQrCode_Base64,
    GetInquiryWxOpenQrCode,
    AgeFrontCheck,
    GetUsedDrugsList,
    GetDrugByUpcCode,
    IOSLogin,
    GetDoctorInfo,
    UnifiedOrder,
    GetPharmacistInfo,
    SearchDoctor,
    GetShopUser,
    GetPharSignList,
    CheckPharV2,
    SaveSignType,
    UploadShopPic,
    ExistShopName,
    GetShopFromImg,
    AddShop,
    EditShop,
    GetPicCodeByUrl,
    AddChainShop,
    GetShopApplyInfo,
    BuyPackageList,
    AuditPrescribeV2,
    EditShopUser,
    CheckPhar,
    GetPackage,
    GetInquiryPicCode,
    GetOrderList,
    GetPatient,
    SavePatient,
    GetDiagnoseByComNames,
    GetPatientList,
    GetInquiryList,
    GetDrugList,
    GetDiseaseList,
    GetPrescribe,
    SaveInquiry,
    UpLoadImg,
    GetInquiry,
    GetInquiryQrCode,
    GetInquiryEncodeData,
    GetSilkBagShortchain
}